import { Typography } from 'antd';


const { Title, Paragraph } = Typography;


const ReportDefault = ({ }) => {
    return <div style={{
        padding: '40px',
        background: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    }}>
        <Title level={3}>Please select a report from the left menu.</Title>
        <Paragraph type="secondary">
            Once you choose a report, the data will appear here.
        </Paragraph>
    </div>
}

export default ReportDefault;